import React from 'react';
import '../styling/App.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="copyright">
        &copy;2026 kevin cen
      </div>
      <div className="copyright">
        Made with React.js
      </div>
    </footer>
  );
};

export default Footer;
